"use client";

import { SessionProvider } from "next-auth/react";
import { CartProvider } from "@/context/CartContext";
import { ToastProvider } from "@/context/ToastContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { WishlistProvider } from "@/context/WishlistContext";
import { SiteConfigProvider } from "@/context/SiteConfigContext";
import { SwrProvider } from "@/components/SwrProvider";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <SwrProvider>
        <SiteConfigProvider>
          <ToastProvider>
            <CurrencyProvider>
              <WishlistProvider>
                <CartProvider>{children}</CartProvider>
              </WishlistProvider>
            </CurrencyProvider>
          </ToastProvider>
        </SiteConfigProvider>
      </SwrProvider>
    </SessionProvider>
  );
}
